import MetricBase from "models/metrics/MetricBase";
import PerformanceGroup from "models/groups/PerformanceGroup";
import CurrencyUnit from "models/metrics/unit/CurrencyUnit";
import i18n from "i18next";

class MetricSpent extends MetricBase {
    constructor() {
        super({
            field: "metric_spent",
            defaultVisibility: true,
            unit: new CurrencyUnit(),
            chartName: i18n.t("metrics.google_hotel_ads.spent.chartName"),
            serieLabel: i18n.t("metrics.google_hotel_ads.spent.serieLabel"),
            tooltip: i18n.t("metrics.google_hotel_ads.spent.tooltip"),
            group: new PerformanceGroup(),
        });
    }
}

export default MetricSpent;
